import { render, staticRenderFns } from "./Visa.vue?vue&type=template&id=e4aeddda&scoped=true&"
import script from "./Visa.vue?vue&type=script&lang=js&"
export * from "./Visa.vue?vue&type=script&lang=js&"
import style0 from "./Visa.vue?vue&type=style&index=0&id=e4aeddda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aeddda",
  null
  
)

export default component.exports